import { useEffect, useState } from "react";
import axios from "axios";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

/* =======Website Setting=========*/
const BannerData = (RendomTokenfetch) => {
  // console.log(Site2Url);
  const [homeBanner, sethomeBanner] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchBannerDataa = async () => {
      if (!RendomTokenfetch) return;
      setLoading(true);
      try {
        const res = await axios.get(`${WebsiteAPIurl}bannerAPI.php`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        });
        // console.log("BAnnerData", res.data);
        if (res.data && res.data.status === "1") {
          sethomeBanner(res.data.bannerdata);
        } else {
          // console.warn("fetch failed:", res.data?.message || "Unknown");
        }
      } catch (err) {
        console.error("Fetch Error:", err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBannerDataa();
  }, [RendomTokenfetch]);

  return [homeBanner, loading, error];
};

const BlogLimitData = (RendomTokenfetch) => {
  const [LatestBlogLimit, setLatestBlogLimit] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchBannerDataa = async () => {
      if (!RendomTokenfetch) return;
      setLoading(true);
      try {
        const res = await axios.get(`${WebsiteAPIurl}homeblogAPI.php`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        });
        // console.log("BAnnerData", res.data);
        if (res.data && res.data.status === "1") {
          setLatestBlogLimit(res.data.blogdata);
        } else {
          // console.warn("fetch failed:", res.data?.message || "Unknown");
        }
      } catch (err) {
        console.error("Fetch Error:", err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBannerDataa();
  }, [RendomTokenfetch]);
  return [LatestBlogLimit, loading, error];
};

const GalleryData = (RendomTokenfetch) => {
  const [DataGallery, setDataGallery] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchDataGallery = async () => {
      if (!RendomTokenfetch) return;
      setLoading(true);
      try {
        const res = await axios.get(`${WebsiteAPIurl}galleryAPI.php`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        });
        // console.log("BAnnerData", res.data);
        if (res.data && res.data.status === "1") {
          setDataGallery(res.data.gallerydata);
        } else {
          // console.warn("fetch failed:", res.data?.message || "Unknown");
        }
      } catch (err) {
        console.error("Fetch Error:", err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDataGallery();
  }, [RendomTokenfetch]);
  return [DataGallery, loading, error];
};

const AboutFetchData = (RendomTokenfetch) => {
  const [AboutData, setAboutData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchAboutDataa = async () => {
      if (!RendomTokenfetch) return;
      setLoading(true);
      try {
        const res = await axios.get(`${WebsiteAPIurl}aboutUsAPI.php`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        });
        // console.log("About Data", res.data);
        if (res.data && res.data.status === "1") {
          setAboutData(res.data.sitedata);
        } else {
          // console.warn("fetch failed:", res.data?.message || "Unknown");
        }
      } catch (err) {
        console.error("Fetch Error:", err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAboutDataa();
  }, [RendomTokenfetch]);

  return [AboutData, loading, error];
};

const NriCornerData = (RendomTokenfetch) => {
  const [NriData, setNriData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchNriData = async () => {
      if (!RendomTokenfetch) return;
      setLoading(true);
      try {
        const res = await axios.get(`${WebsiteAPIurl}nricornerAPI.php`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        });
        // console.log("BAnnerData", res.data);
        if (res.data && res.data.status === "1") {
          setNriData(res.data.sitedata);
        } else {
          // console.warn("fetch failed:", res.data?.message || "Unknown");
        }
      } catch (err) {
        console.error("Fetch Error:", err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNriData();
  }, [RendomTokenfetch]);

  return [NriData, loading, error];
};

const ServiceFetchData = (RendomTokenfetch) => {
  const [ServiceData, setServiceData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchAboutDataa = async () => {
      if (!RendomTokenfetch) return;
      setLoading(true);
      try {
        const res = await axios.get(`${WebsiteAPIurl}serviceAPI.php`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        });
        // console.log("ServiceData", res.data);
        if (res.data && res.data.status === "1") {
          setServiceData(res.data.servicedata);
        } else {
          setServiceData([]);
          // console.warn("fetch failed:", res.data?.message || "Unknown");
        }
      } catch (err) {
        console.error("Fetch Error:", err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAboutDataa();
  }, [RendomTokenfetch]);

  return [ServiceData, loading, error];
};

const ProjectCatFetchData = (RendomTokenfetch) => {
  const [ProjectCatData, setProjectCatData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchCatDataa = async () => {
      if (!RendomTokenfetch) return;
      setLoading(true);
      try {
        const res = await axios.get(`${WebsiteAPIurl}projectCategoryAPI.php`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        });
        // console.log("ServiceData", res.data);
        if (res.data && res.data.status === "1") {
          setProjectCatData(res.data.categorydata);
        } else {
          setProjectCatData([]);
          // console.warn("fetch failed:", res.data?.message || "Unknown");
        }
      } catch (err) {
        console.error("Fetch Error:", err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCatDataa();
  }, [RendomTokenfetch]);

  return [ProjectCatData, loading, error];
};

const WhyChooseFetchData = (RendomTokenfetch) => {
  const [WhyChooseData, setWhyChooseData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchWhyChooseData = async () => {
      if (!RendomTokenfetch) return;
      setLoading(true);
      try {
        const res = await axios.get(`${WebsiteAPIurl}whyChooseAPI.php`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        });
        // console.log("BAnnerData", res.data);
        if (res.data && res.data.status === "1") {
          setWhyChooseData(res.data.whychoosedata);
        } else {
          setWhyChooseData([]);
          // console.warn("fetch failed:", res.data?.message || "Unknown");
        }
      } catch (err) {
        console.error("Fetch Error:", err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchWhyChooseData();
  }, [RendomTokenfetch]);

  return [WhyChooseData, loading, error];
};

export default BannerData;
export {
  BlogLimitData,
  AboutFetchData,
  ServiceFetchData,
  WhyChooseFetchData,
  NriCornerData,
  GalleryData,
  ProjectCatFetchData,
};
